/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-30 21:37:01
 * @LastEditTime: 2020-08-31 09:13:13
 * @Description: 销售订单评论
 */
import axios from '@/utils/axios'

export const getSalesOrderCommentList = (payload) => {
    return axios.get('/salesOrderComment', {
        params: payload
    })
}

export const updateSalesOrderComment = (id, data) => {
    return axios.put(`/salesOrderComment/${id}`, data)
}

export const createSalesOrderComment = (data) => {
    return axios.post(`/salesOrderComment`, data)
}